import { Component } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { CommonEventService } from '../services/common-event.service';
import * as $ from 'jquery';
import Swal from 'sweetalert2';
import { HostListener } from '@angular/core';
import { LocationStrategy } from '@angular/common';

@Component({
  selector: 'app-quote-status',
  templateUrl: './quote-status.component.html',
  styleUrls: ['./quote-status.component.css']
})
export class QuoteStatusComponent {
  fisrtSavedMessageText: any;
  remainingSaveQuoteSentence:any;
  flowActivityId:any='';
  constructor(private router: Router,public apiService:ApiService,private modalService: NgbModal,public commonService : CommonEventService,
    private activatedRoute: ActivatedRoute,private location: LocationStrategy){
      $('#guestSaveQuoteProcess').hide();
      if(localStorage.getItem('apDtId')){
        $('#guestSaveQuoteProcess').show();
        // let apiObj:any = localStorage.getItem('apiSerDataObj')
        // let commonObj:any = localStorage.getItem('commonDataObj')
        // this.apiService.apiMainObj = JSON.parse(apiObj) 
        // this.commonService.commonMainObj = JSON.parse(commonObj)
      }
  }

  ngOnInit(): void {
    this.restrictBrowserButtons();
    setTimeout(()=>{
      window.scrollTo(0, 0);
    },200);
    this.activatedRoute.queryParams.subscribe(params => {
      if(params['data']){
        this.apiService.getAppStoreData(localStorage.getItem('apDtId')).subscribe((storeAppDataObj) =>{
          let strAppDt = JSON.parse(storeAppDataObj.fileData)
          this.apiService.apiMainObj = JSON.parse(strAppDt.data['apiSerDataObj'])
          this.commonService.commonMainObj = JSON.parse(strAppDt.data['commonDataObj'])
          this.userSessionCheck(params['data']);
        })
      }else{
        this.goToSaveQuote();
      }
    })
  }
  restrictBrowserButtons(){
    this.commonService.commonMainObj.openCheck = false;
    history.pushState({}, '', window.location.href);
    this.location.onPopState(() => {
      console.log("BACK BUTTON CLICKED ON QUOTE STATUS PAGE");
      history.pushState({}, '', window.location.href);
      if(!this.commonService.commonMainObj.openCheck){
        this.restrictBrowserButtonsAlert();
      }
    });
  }
  restrictBrowserButtonsAlert(){
    this.commonService.commonMainObj.openCheck = true;
    Swal.fire({
      title: 'Alert!',
      text:"Navigating back will result in the loss of data",
      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // if(cnfmBtnText == 'Re-Upload Files'){
        //   let element: HTMLElement = document.querySelector('input[type="file"]') as HTMLElement;
        //   element.click();
        // }
        this.commonService.goBack();
      } else if (result.isDismissed) {
        this.commonService.commonMainObj.openCheck = false;
      }
    })
  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event:any) {
    console.log('Back button pressed');
    event.preventDefault();
    this.restrictBrowserButtons();
  }
  
  userSessionCheck(sessionData:any){
    $('#finalQuoteDetails').hide();
    $(".progress-bar").width('60%');
    $('#saveQuoteSuccessData').hide();
    this.apiService.apiMainObj.encUrlData = sessionData
    this.apiService.getUserDataSession(sessionData).subscribe((resData: any)=>{
      this.commonService.commonMainObj.userSessionMemberId = resData.memberId;
      if(localStorage.getItem('apDtId')){
        if(resData && resData.status == "NO_SESSION"){
          this.commonService.commonMainObj.userData = {};
          this.commonService.commonMainObj.sessionCheck = false;
          this.commonService.commonMainObj.isGuestUser = true;
          this.router.navigateByUrl('/quoteDetails');
        }else if(resData && resData.status == 'SESSION_FOUND'){
          if(this.commonService.commonMainObj.email && resData.registrationEmail != this.commonService.commonMainObj.email){
            this.commonService.commonMainObj.invalidUser = true;
            this.commonService.commonMainObj.loginEmail = resData.registrationEmail
            this.commonService.commonMainObj.boardDetailsDataObj.email = resData.registrationEmail;
          }
          this.commonService.commonMainObj.userId = resData.userId
          this.commonService.commonMainObj.userData = resData;
          this.commonService.commonMainObj.sessionCheck  = true;
          this.commonService.commonMainObj.isGuestUser = false;
          if(this.commonService.commonMainObj.customAssemblySelected == true){
            this.apiService.getSavedBomFIleData(this.commonService.commonMainObj.savedBomFileName).subscribe((data) =>{
              this.commonService.commonMainObj.retrivedBomFileDta =data.body;
              this.goToSaveQuote();
            }, error =>{
              console.log('Bom file saving Error1', error);
            });
          }else{
            this.goToSaveQuote();
          }
        }
      }else{
        this.router.navigateByUrl('/quoteDetails');
      }
    },err=>{
      if(err.status == 200){
        if(err.error.text == "NO_SESSION"){
          this.commonService.commonMainObj.sessionCheck = false;
        }else{
          this.commonService.commonMainObj.userData = {};
        }
      }else{
        
      }
      console.log(err)
    });
  }

  goToSaveQuote(){
    this.commonService.issuesListObjFn();
    $(".progress-bar").width('75%');
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    if(this.commonService.commonMainObj.tryToSigninOrRegister ){
      var saveQuoteClickForSigninObj ={
        "signIn": this.commonService.commonMainObj.invalidUser ? "Sign-in failed": this.commonService.commonMainObj.newUser? 'Registration successful':'Sign-in successful'
      }
      this.apiService.updateDetailsToDashboard(this.flowActivityId,saveQuoteClickForSigninObj,'SignInRegistrationPage').subscribe((resDatas)=>{
        // console.log("updateDetailsToDashboard",resDatails);
      });
    }
    if(this.commonService.commonMainObj.pcbType == 'Web PCB' || this.commonService.commonMainObj.pcbType == 'Product 1' || this.commonService.commonMainObj.pcbType == 'Product 2'){
      setTimeout(() => {
        if(this.commonService.commonMainObj.invalidUser){
          $('#finalQuoteDetails').hide();
          $('#guestSaveQuoteProcess').hide();
          return false;
        }
      }, 1000);
      var saveQuoteObj:any = {};
      saveQuoteObj.fileName = this.commonService.commonMainObj.uploadedFileName;
      saveQuoteObj.s3FileId = (this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.'));
      //saveQuoteObj.issueDetails = this.commonService.commonMainObj.fabIssuesListArray;
      this.commonService.commonMainObj.issueDetails['issueDetailList'] = this.commonService.commonMainObj.fabIssuesListArray;
      this.commonService.commonMainObj.issueDetails['bomIssueDetailList'] = this.commonService.commonMainObj.bomIssuesListArray;
      saveQuoteObj.issueDetails = this.commonService.commonMainObj.issueDetails;
      // var formData = new FormData();
      // formData.append('issueDetails',JSON.stringify(this.commonService.commonMainObj.fabIssuesListArray));
      this.commonService.loadingShow();
      this.apiService.saveQuoteApi(saveQuoteObj).subscribe((data:any) => {
        $(".progress-bar").width('100%');
        if(data){
          this.commonService.loadingHide();
          // console.log("save quote data", data);
          $('#saveQuoteSuccessData').show();
          if(data.spx != '' && data.message == ''){ //Success
            this.commonService.commonMainObj.saveQuoteAccessUrl = data.accessUrl;
            this.commonService.commonMainObj.spx = data.spx;
            var saveQuoteDataObj={
              "spx": this.commonService.commonMainObj.spx,
              "quoteId" : data.quoteNumber
            }
            this.apiService.updateDetailsToDashboard(this.flowActivityId,saveQuoteDataObj,'ConfirmQuoteRequestPage').subscribe((resDatas)=>{
              // console.log("updateDetailsToDashboard",resDatails);
            });
          }else{
            this.commonService.commonMainObj.saveQuoteMessage = data.message;
            let firstSpaceIndex =  data.message.indexOf(' ');
            let wordWithHyphen = data.message.match(/\w+-\w+/);
            // console.log("wordWithHyphen",wordWithHyphen);
            this.fisrtSavedMessageText = data.message.split(" ");
            this.fisrtSavedMessageText = this.fisrtSavedMessageText[0];
            if (firstSpaceIndex !== -1) {
              // Extract the substring starting from the character after the first space
              this.remainingSaveQuoteSentence = data.message.substring(firstSpaceIndex + 1);
            } 
          }
          $('#finalQuoteDetails').hide();
          $('#guestSaveQuoteProcess').hide();
          
        }
      },error => {
        this.commonService.loadingHide();
        console.log("Error in saving the quote",error);
      });
      
    }else{
      var designFileDetails = {
        "bomFileName" : this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name?this.commonService.commonMainObj.uploadedFile.name:this.commonService.commonMainObj.uploadedBomFileName  : Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0] ? Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]:'',
      };
      this.commonService.commonMainObj.boardDetailsDataObj.minimumSpace = this.commonService.commonMainObj.boardDetailsDataObj.minimumSpace == "Other"? "Choose" : this.commonService.commonMainObj.minSpaceInMils;
      this.commonService.commonMainObj.boardDetailsDataObj.minimumSpaceInnerLyr = this.commonService.commonMainObj.boardDetailsDataObj.minimumSpaceInnerLyr == "Other" ? "Choose" : this.commonService.commonMainObj.innerMinSpaceInMils;
      this.commonService.commonMainObj.boardDetailsDataObj.minimumTrace = this.commonService.commonMainObj.boardDetailsDataObj.minimumTrace == "Other" ? "Choose" : this.commonService.commonMainObj.minTraceInMils;
      this.commonService.commonMainObj.boardDetailsDataObj.minimumTraceInnerLyr = this.commonService.commonMainObj.boardDetailsDataObj.minimumTraceInnerLyr == "Other" ? "Choose" : this.commonService.commonMainObj.innerMinTraceInMils;
      this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper = this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper == "Other" ? "Choose" : this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper;
      this.commonService.commonMainObj.boardDetailsDataObj.outerLyrFinishCopper = this.commonService.commonMainObj.boardDetailsDataObj.outerLyrFinishCopper == "Other" ? "Choose" : this.commonService.commonMainObj.boardDetailsDataObj.outerLyrFinishCopper;
      this.commonService.commonMainObj.boardDetailsDataObj.controlledImpedance = this.commonService.commonMainObj.boardDetailsDataObj.controlledImpedance == "Other" ? "Choose" : this.commonService.commonMainObj.controlledImpedance;
      this.commonService.commonMainObj.boardDetailsDataObj.material = this.commonService.commonMainObj.boardDetailsDataObj.material == "Other" ? "Choose":this.commonService.commonMainObj.boardDetailsDataObj.material;
      this.commonService.commonMainObj.boardDetailsDataObj.finishedThickness = this.commonService.commonMainObj.boardDetailsDataObj.finishedThickness == "Other" ? "Choose":this.commonService.commonMainObj.boardDetailsDataObj.finishedThickness;
      this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish = this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish == "other" ? "Choose":this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish;
      this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType == "Other" ? "Choose":this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType;
      this.commonService.commonMainObj.boardDetailsDataObj.minHoleSize = this.commonService.commonMainObj.minHoleSizeInMils;
      this.commonService.commonMainObj.boardDetailsDataObj.gerbersProvided = this.commonService.commonMainObj.gerbersProvided;
      // condition removed for OFP-1156
      // && this.commonService.commonMainObj.customAssemblySelected == true ?
      this.commonService.commonMainObj.boardDetailsDataObj.odbFilesAvailable = this.commonService.commonMainObj.odbFilesAvailable == 'Yes' ? 'Yes' : 'No';
      this.commonService.commonMainObj.boardDetailsDataObj.layerOrderProvided = this.commonService.commonMainObj.layerOrderProvided;
      this.commonService.commonMainObj.boardDetailsDataObj.boardOutlineProvided = this.commonService.commonMainObj.boardOutlineProvided;
      this.commonService.commonMainObj.boardDetailsDataObj.drillFileProvided = this.commonService.commonMainObj.drillFileProvided;
      this.commonService.commonMainObj.boardDetailsDataObj.fabDrawingProvided = this.commonService.commonMainObj.fabDrawingProvided;
      this.commonService.commonMainObj.boardDetailsDataObj.assemblyBomAvailable = this.commonService.commonMainObj.customAssemblySelected == true ? 'Yes':'No';
      this.commonService.commonMainObj.boardDetailsDataObj.numberOfSidesToBeAssembled = this.commonService.commonMainObj.customAssemblySides;
      this.commonService.commonMainObj.boardDetailsDataObj.leadFreeProcessing = this.commonService.commonMainObj.customLeadFreeProcessing;
      this.commonService.commonMainObj.boardDetailsDataObj.thruHoleViainPad = this.commonService.commonMainObj.customViaInPadData;
      this.commonService.commonMainObj.boardDetailsDataObj['issuesInDesignPackage'] = this.commonService.commonMainObj.fabIssuesListArray;
      this.commonService.commonMainObj.boardDetailsDataObj.doesAssemblyHaveComponentsThatCannotBeWashed=this.commonService.commonMainObj.aqueousSelectOption =="Yes"?'Yes':'No';
      this.commonService.commonMainObj.boardDetailsDataObj.quantityIfComponentsThatCannotBeWashed =  this.commonService.commonMainObj.listOfMpnsSelected? this.commonService.commonMainObj.listOfMpnsSelected.length:'';
      this.commonService.commonMainObj.boardDetailsDataObj.referenceDesignatorsOfComponentsThatCannotBeWashed=this.commonService.commonMainObj.listOfMpnsSelected? this.commonService.commonMainObj.refDesignatorCannotBewashed:''
      var customQuoteSaveObj:any = {};
      const formData = new FormData();
      let bomFileNamee :any ='';
      if(this.commonService.commonMainObj.fileUploadedData.uploadedBOM && this.commonService.commonMainObj.autoUploadFileName){
        bomFileNamee = this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name?this.commonService.commonMainObj.uploadedFile.name:this.commonService.commonMainObj.uploadedBomFileName  : Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0] ? Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]:this.commonService.commonMainObj.savedBomFileName != '' ? this.commonService.commonMainObj.savedBomFileName.split("/")[1]:'';
      }else{
        bomFileNamee = this.commonService.commonMainObj.savedBomFileName == '' ? this.commonService.commonMainObj.uploadedFile?this.commonService.commonMainObj.uploadedFile.name?this.commonService.commonMainObj.uploadedFile.name:this.commonService.commonMainObj.uploadedBomFileName  : Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0] ? Object.values(this.commonService.commonMainObj.fileUploadedData.uploadedBOM)[0]:'':this.commonService.commonMainObj.savedBomFileName.split("/")[1] ;
      }
      customQuoteSaveObj.pcbCustomQuoteRequest={
        "pcbQuoteRequest":this.commonService.commonMainObj.boardDetailsDataObj,
        "customQuoteDesignFileDetails":{
          "bomFileName":this.commonService.commonMainObj.customAssemblySelected == true ? bomFileNamee:''
        },
        "fileName":this.commonService.commonMainObj.uploadedFileName,
        "s3FileId":(this.commonService.commonMainObj.s3FileName.split('.').slice(0, -1).join('.'))
      };
      customQuoteSaveObj.customBomPriceItem ={
       "bom_id": "",
       "customBomItems":this.commonService.commonMainObj.customBomPriceItems,
       "fileName": this.commonService.commonMainObj.customAssemblySelected == true ? bomFileNamee:''
      };  
      let bomFileContent :any='';
      bomFileContent =  this.commonService.commonMainObj.retrivedBomFileDta != '' ?this.commonService.commonMainObj.retrivedBomFileDta:this.commonService.commonMainObj.bomFileData; 
      formData.append('pcbCustomQuoteRequest', JSON.stringify(customQuoteSaveObj.pcbCustomQuoteRequest));
      formData.append('assemblyQuantity',this.commonService.commonMainObj.customQtyOfAssemblies);
      formData.append('userID',this.commonService.commonMainObj.userId);
      formData.append('customBomPriceItem', JSON.stringify(customQuoteSaveObj.customBomPriceItem));
      formData.append('customBomFile',bomFileContent);
      // if(!localStorage.getItem('apiSerDataObj') && !localStorage.getItem('commonDataObj')){
      if(!localStorage.getItem('apDtId')){
        this.commonService.loadingShow();
      }
      this.apiService.createPcbCustomQuote(formData).subscribe((data:any) => {
        $(".progress-bar").width('100%');
        $('#guestSaveQuoteProcess').hide();
        if(data){
          this.commonService.loadingHide();
          this.commonService.commonMainObj.rNumber = data.requestNumber;
          this.commonService.commonMainObj.accountManagerEmail = data.accountManagerEmail;
          this.commonService.commonMainObj.accountManagerName = data.accountManagerName;
          this.commonService.commonMainObj.accountManagerPhone = data.accountManagerPhone;
          this.commonService.commonMainObj.spxNumber = data.spxNumber;
          this.commonService.commonMainObj.spxLink = data.spxLink;
          var customQuoteObj ={
            "rNumber":this.commonService.commonMainObj.rNumber,
            "spx":this.commonService.commonMainObj.spxNumber
          }
          this.apiService.updateDetailsToDashboard(this.flowActivityId,customQuoteObj,'ConfirmQuoteQuoteDetailsPage').subscribe((resDatas)=>{
            // console.log("updateDetailsToDashboard",resDatails);
          });
          $('#finalQuoteDetails').hide();
        }
      },error => {
        this.commonService.loadingHide();
        console.log("Error in getting PCB final quote",error);
        $('#finalQuoteDetails').show();
      });
    }
  }
  
}
